/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import TableCell from "@mui/material/TableCell";

// Soft UI Dashboard PRO React components
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";

const compactCellSx = {
  px: 0.45,
  py: 0.4,
  lineHeight: 1.15,
  verticalAlign: "middle",
};

const compactHeadingSx = {
  fontSize: "12px !important",
  fontWeight: "400 !important",
  lineHeight: "1.15 !important",
};

const compactDataSx = {
  fontSize: "10px !important",
  fontWeight: "400 !important",
  lineHeight: "1.15 !important",
};

function SalesTableCell({ title, content, image = "", noBorder = false, compact = false, sx = {}, ...rest }) {
  let template;
  const cellSx = {
    border: noBorder ? 0 : undefined,
    ...(compact ? compactCellSx : {}),
    ...sx,
  };
  const titleSx = compact ? compactHeadingSx : undefined;
  const contentSx = compact ? compactDataSx : undefined;

  if (image) {
    template = (
      <TableCell {...rest} align="left" width="30%" sx={cellSx}>
        <SoftBox display="flex" alignItems="center" width="max-content">
          <SoftBox component="img" src={image} alt={content} width="1.5rem" height="auto" />
          <SoftBox display="flex" flexDirection="column" ml={compact ? 0.5 : 3}>
            <SoftTypography
              variant="caption"
              color="text"
              fontWeight={compact ? "regular" : "medium"}
              textTransform="capitalize"
              sx={titleSx}
            >
              {title}:
            </SoftTypography>
            <SoftTypography
              variant="button"
              fontWeight={compact ? "regular" : "medium"}
              textTransform="capitalize"
              sx={contentSx}
            >
              {content}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </TableCell>
    );
  } else {
    template = (
      <TableCell {...rest} align="center" sx={cellSx}>
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography
            variant="caption"
            color="text"
            fontWeight={compact ? "regular" : "medium"}
            textTransform="capitalize"
            sx={titleSx}
          >
            {title}:
          </SoftTypography>
          <SoftTypography
            variant="button"
            fontWeight={compact ? "regular" : "medium"}
            textTransform="capitalize"
            sx={contentSx}
          >
            {content}
          </SoftTypography>
        </SoftBox>
      </TableCell>
    );
  }

  return template;
}


SalesTableCell.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  image: PropTypes.string,
  noBorder: PropTypes.bool,
  compact: PropTypes.bool,
  sx: PropTypes.object,

};

export default SalesTableCell;
